import React, { useState, useEffect } from 'react';
import { toNano, beginCell, Cell, Slice, Address } from '@ton/core';
import { useTonConnectUI, useTonWallet, TonConnectButton, useTonAddress } from '@tonconnect/ui-react';
import './Subscribe.css';
import useAxiosHelper from '../../Common/AxiosHelper';
import { ApiPaths } from '../../Config/ApiPath';
import { toastFailed, toastSuccess } from '../../Config/BasicInfo';
import { getRegisterFeeFromContract, tonToNano, nanoToTon } from '../../Common/GetContractData';
import { useNavigate } from 'react-router-dom';
const Subscribe = ({ userdata }) => {
    const navigate = useNavigate();
    const { AxiosPost } = useAxiosHelper();
    const walletAddress = useTonAddress();
    const [isLoading, setIsLoading] = useState(false);
    const [transactionStatus, setTransactionStatus] = useState('');
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [registerFee, setRegisterFee] = useState(null); // Default fee

    // Use TonConnect for wallet integration
    const [tonConnectUI] = useTonConnectUI();
    const wallet = useTonWallet();
    const connected = !!wallet;
    const account = wallet?.account;
    // const subscriptionContractAddress = 'EQDA48vxE6lLywP5Uv7-C571s_-CtmvoNOtaMKBgcVsWVJsR';
    const subscriptionContractAddress = 'EQCiy4SfSLnNPviAoAJvJhlh6hjOEX5SR9dm-4dg5KV4y8Kb';

    // Function to get REGISTER_FEE from contract using API
    const fetchRegisterFee = async () => {
        try {
            const fee = await getRegisterFeeFromContract(subscriptionContractAddress);
            setRegisterFee(fee);
            console.log('Register fee from contract:', fee, 'TON');
        } catch (error) {
            console.error('Error fetching register fee:', error);
            // Keep default fee if API call fails
        }
    };

    // Update subscription amount when fee is retrieved
    useEffect(() => {
        // Fetch fee when component mounts
        fetchRegisterFee();
    }, []);

    // Update the subscription amount to use the dynamic fee
    const subscriptionAmount = registerFee; // Now uses the fee from contract

    const handlePayClick = () => {
        setShowConfirmation(true);
    };

    const handleConfirmPayment = async () => {
        setShowConfirmation(false);
        await handleSubscribe();
    };

    const handleCancelPayment = () => {
        setShowConfirmation(false);
    };

    const handleSubscribe = async (orderId) => {
        setIsLoading(true);
        setTransactionStatus('Preparing subscription transaction...');

        try {
            if (!connected || !account) {
                setTransactionStatus('Error: Please connect your wallet first');
                setIsLoading(false);
                return;
            }

            const payloadCell = beginCell().storeUint(0, 32).storeStringTail("register").endCell();
            const payloadBase64 = payloadCell.toBoc().toString('base64');

            // Prepare transaction
            const transaction = {
                validUntil: Math.floor(Date.now() / 1000) + 60, // valid for 60s
                messages: [
                    {
                        address: subscriptionContractAddress,
                        amount: toNano(subscriptionAmount).toString(), // $1 worth of TON
                        payload: payloadBase64,
                    }
                ]
            };

            // Send transaction
            const sendResult = await tonConnectUI.sendTransaction(transaction);
            console.log('Subscription transaction result:', sendResult);

            confirmSubscription(orderId);


            // You can add API call here to update user subscription status in your backend
            // await updateUserSubscriptionStatus(account.address);

        } catch (error) {
            console.error('Error sending subscription transaction:', error);
            setTransactionStatus(`Error: ${error.message}`);
            setIsLoading(false);
        } finally {
        }
    };

    async function confirmSubscription(orderId) {
        console.log('orderId', orderId);
        try {
            const body = {
                tx_id: orderId
            }
            const response = await AxiosPost(ApiPaths.confirmAddFund, body);
            console.log('response', response);
            toastSuccess(response?.message);
            setTransactionStatus('✅ Subscription successful! Transaction sent.');
            setIsSubscribed(true);
            showConfirmation(false);
            navigate(0);
        } catch (e) {
            toastFailed(e.response?.data?.message);
            console.log("error", e.response?.data?.message);
        } finally {
            setIsLoading(false);
        }
    }

    const handleDisconnect = () => {
        tonConnectUI.disconnect();
        setTransactionStatus('');
        setIsSubscribed(false);
    };

    const handleSubscribeApi = async () => {
        try {
            const body = {
                address: walletAddress
            }
            const tempDepositData = await AxiosPost(
                ApiPaths.placeAddFundwithdap,
                body);
            console.log("tempDepositData", tempDepositData);
            if (tempDepositData?.orderDetail?.tx_Id) {
                handleSubscribe(tempDepositData?.orderDetail?.tx_Id);
            } else {
                toastFailed("transaction failed");
            }
        } catch (error) {
            toastFailed(error.response?.data?.message);
            console.log("error", error);
        }
    }

    return (
        <div className="subscribe-container">
            {/* <button onClick={handleChangeOwner}>call</button> */}
            <div className="subscribe-content">
                <div className="subscription-card">

                    <div className="subscription-right">
                        <div className="wallet-section">
                            {userdata?.registered_in_airdrop == true ? (
                                <div className="premium-subscribed-status">
                                    <div className="premium-badge">
                                        <span className="badge-icon">✨</span>
                                        <span>Airdrop Subscribed</span>
                                    </div>
                                </div>
                            ) : connected ? (
                                <div className="wallet-connected">
                                    <div className="Subscribed-wallet-info">
                                        <span className="status-indicator connected"></span>
                                        <span className="wallet-address">
                                            {account?.address?.slice(0, 8)}...{account?.address?.slice(-8)}
                                        </span>
                                        {/* Elegant Disconnect Button */}
                                        <button
                                            onClick={handleDisconnect}
                                            className="elegant-disconnect-btn"
                                            title="Disconnect Wallet"
                                        >
                                            <svg className="disconnect-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M16 17L21 12L16 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M21 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </button>
                                    </div>

                                    {isSubscribed ? (
                                        <div className="subscription-success">
                                            <div className="success-icon">🎉</div>
                                            <p>You are now subscribed!</p>
                                        </div>
                                    ) : (
                                        <button
                                            onClick={handlePayClick}
                                            disabled={isLoading}
                                            className="subscribe-btn"
                                        >
                                            {isLoading ? (
                                                <span className="loading-spinnernew">
                                                    <div className="spinner"></div>
                                                    Processing...
                                                </span>
                                            ) : (
                                                `Pay ${parseFloat(subscriptionAmount).toFixed(2)} TON`
                                            )}
                                        </button>
                                    )}
                                </div>
                            ) : (
                                <div className="wallet-disconnected">
                                    <div className="connect-prompt">
                                        <span className="status-indicator disconnected"></span>
                                        <span>Connect your TON wallet to subscribe</span>
                                    </div>
                                    <TonConnectButton />
                                </div>
                            )}
                        </div>

                        {transactionStatus && (
                            <div className={`transaction-status ${transactionStatus.includes('Error') ? 'error' : 'success'}`}>
                                {transactionStatus}
                            </div>
                        )}

                        {/* <div className="subscription-note">
                            <p>
                                💡 Payment in TON cryptocurrency (≈ $1 USDT)
                            </p>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* Confirmation Popup */}
            {showConfirmation && (
                <div className="confirmation-overlay">
                    <div className="confirmation-popup">
                        <div className="popup-header">
                            <h3>Confirm Subscription</h3>
                            <button
                                onClick={handleCancelPayment}
                                className="close-btn"
                            >
                                ×
                            </button>
                        </div>

                        <div className="popup-content">
                            <div className="warning-icon">⚠️</div>
                            <p className="confirmation-message">
                                You are about to set the selected wallet address as your primary account for this subscription.
                            </p>
                            <p className="confirmation-details">
                                <strong>Wallet Address:</strong> {account?.address?.slice(0, 12)}...{account?.address?.slice(-12)}
                            </p>
                            <p className="confirmation-details">
                                <strong>Payment Amount :</strong> {subscriptionAmount != null && parseFloat(subscriptionAmount).toFixed(2)} TON
                            </p>
                            <p className="confirmation-note">
                                This action will link your wallet address to your account and process the payment.
                                Please ensure this is the correct wallet address before proceeding.
                            </p>
                        </div>

                        <div className="popup-actions">
                            <button
                                onClick={handleCancelPayment}
                                className="cancel-btn"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleSubscribeApi}
                                className="confirm-btn"
                            >
                                Confirm & Proceed
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Subscribe;